import React from "react";
import AuthPage from "@/components/ui/AuthPage";
import { MdDeleteOutline } from "react-icons/md";
import { connect } from "react-redux";
import useStyles from './DeleteAccountConfirmationCardStyles';
import {
    Container,
    Button
} from '@mui/material';
import { MdDone } from "react-icons/md";
import { useParams } from 'react-router-dom';
import { hideProgressSpinner, showProgressSpinner } from '@/lib/utils/ProgressSpinnerService';
import { handleDeleteAccountConfirmation } from './../../pages/Profile/store/Profile';
import ns from '@/lib/utils/NotificationService';
import useHistory from "../../lib/hooks/useHistory";

interface Props {
    settings: any,
    handleDeleteAccountConfirmation_d: (userId: string, tokenId: string, onCompletedCallback: (response: any) => void) => void,
}

const DeleteAccountConfirmationCard: React.FC<Props> = props => {

    const { classes } = useStyles()
    const history = useHistory();

    const { userId }: any = useParams();
    const { tokenId }: any = useParams();

    const {
        settings,
        handleDeleteAccountConfirmation_d
    } = props;

    const navigateForward = () => {
        let path = '/deleteAccountConfirmed';
        history.push(path);
    }

    const navigateBack = () => {
        let path = '/home';
        history.push(path);
    }

    const onSubmit = () => {
        showProgressSpinner({ description: 'Deleting Account...' });
        handleDeleteAccountConfirmation_d(userId, tokenId, (res) => {
            if (res.success) {
                navigateForward();
            }
            else {
                ns.error("", res.error)
            }
            hideProgressSpinner();
        });
    }

    return (
        <AuthPage
            title="Are you sure you want to delete your account?"
            icon={<MdDeleteOutline />}
            iconTone="bad"
            actions={<>
                <button type="submit" className="pb-btn pb-btn-danger" onClick={onSubmit}>Delete Account</button>
                <button type="button" className="pb-btn pb-btn-outline" onClick={navigateBack}>Cancel</button>
            </>}>
            <p>Take note that this cannot be undone. Once you submit, your account will be permanently deleted.</p>
        </AuthPage>
    )

}

const mapStateToProps = (state: any) => ({
    settings: state.settings.settings,
});

const mapDispatchToProps = (dispatch: any) => {
    return {
        handleDeleteAccountConfirmation_d: (userId: string, tokenId: string, onCompletedCallback: (response: any) => void) => dispatch(handleDeleteAccountConfirmation(userId, tokenId, onCompletedCallback)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(DeleteAccountConfirmationCard);
